// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"422":"8ff0721e","833":"29d99e06"}[chunkId] + ".chunk.js";
};